import {Checkbox, CheckboxProps, Input, message} from "antd";
import {usePrebookingRequest} from "../../data/PrebookingRequest";
import {useState} from "react";
import {Col, Row} from "react-grid-system";

interface GuestInfoFormProps {
    messageApi: ReturnType<typeof message.useMessage>[0];
}

function GuestInfoForm(props: GuestInfoFormProps) {
    const preBookingRequest = usePrebookingRequest(state => state.prebooking);
    const updateGuestInfo = usePrebookingRequest(state => state.updateGuestInfo);
    const setInfoProvided = usePrebookingRequest(state => state.setInfoProvided);

    const [name, setName] = useState<string>(preBookingRequest?.guestInfo?.name ?? "");
    const [surName, setSurName] = useState<string>(preBookingRequest?.guestInfo?.surName ?? "");
    const [streetAndNumber, setStreetAndNumber] = useState<string>(preBookingRequest?.guestInfo?.address.split("\n")[0] ?? "");
    const [zipAndCity, setZipAndCity] = useState<string>(preBookingRequest?.guestInfo?.address.split("\n")[1] ?? "");
    const [country, setCountry] = useState<string>(preBookingRequest?.guestInfo?.address.split("\n")[2] ?? "");
    const [email, setEmail] = useState<string>(preBookingRequest?.guestInfo?.email ?? "");
    const [confirmedGTC, setConfirmedGTC] = useState<boolean>(false)
    const [confirmedWSDCRules, setConfirmedWSDCRules] = useState<boolean>(false)

    function handleChange(name: string, surName: string, streetAndNumber: string, zipAndCity: string, country: string, email: string, confirmedGTC: boolean, confirmedWSDCRules: boolean) {
        updateGuestInfo({
            name: name,
            surName: surName,
            address: streetAndNumber + "\n" + zipAndCity + "\n" + country,
            email: email,
            wsdcId: preBookingRequest?.guestInfo?.wsdcId ?? null
        }, () => {
            if (name !== "" && surName !== "" && streetAndNumber !== "" && zipAndCity !== "" && country !== "" && email !== "" && confirmedGTC && confirmedWSDCRules) {
                setInfoProvided(true);
            } else {
                setInfoProvided(false);
            }
        })
    }

    function changeName(e: React.ChangeEvent<HTMLInputElement>) {
        setName(e.target.value);
        handleChange(e.target.value, surName, streetAndNumber, zipAndCity, country, email, confirmedGTC, confirmedWSDCRules);
    }

    function changeSurName(e: React.ChangeEvent<HTMLInputElement>) {
        setSurName(e.target.value);
        handleChange(name, e.target.value, streetAndNumber, zipAndCity, country, email, confirmedGTC, confirmedWSDCRules);
    }

    function changeStreetAndNumber(e: React.ChangeEvent<HTMLInputElement>) {
        setStreetAndNumber(e.target.value);
        handleChange(name, surName, e.target.value, zipAndCity, country, email, confirmedGTC, confirmedWSDCRules);
    }

    function changeZipAndCity(e: React.ChangeEvent<HTMLInputElement>) {
        setZipAndCity(e.target.value);
        handleChange(name, surName, streetAndNumber, e.target.value, country, email, confirmedGTC, confirmedWSDCRules);
    }

    function changeCountry(e: React.ChangeEvent<HTMLInputElement>) {
        setCountry(e.target.value);
        handleChange(name, surName, streetAndNumber, zipAndCity, e.target.value, email, confirmedGTC, confirmedWSDCRules);
    }

    function changeEmail(e: React.ChangeEvent<HTMLInputElement>) {
        setEmail(e.target.value);
        handleChange(name, surName, streetAndNumber, zipAndCity, country, e.target.value, confirmedGTC, confirmedWSDCRules);
    }

    const confirmGTC: CheckboxProps['onChange'] = (e) => {
        setConfirmedGTC(e.target.checked);
        handleChange(name, surName, streetAndNumber, zipAndCity, country, email, e.target.checked, confirmedWSDCRules);
    };

    const confirmWSDCRules: CheckboxProps['onChange'] = (e) => {
        setConfirmedWSDCRules(e.target.checked);
        handleChange(name, surName, streetAndNumber, zipAndCity, country, email, confirmedGTC, e.target.checked);
    };

    return (
        <div>
            <Row gutterWidth={20} style={{padding: "0px 0px"}}>
                <Col xl={6}>
                    <p style={{marginBottom: "2px"}}><b>First Name:</b></p>
                    <Input placeholder="Melanie" size="large" value={name} onChange={changeName}></Input>
                </Col>
                <Col xl={6}>
                    <p style={{marginBottom: "2px"}}><b>Last Name:</b></p>
                    <Input placeholder="Musterfrau" size="large" value={surName} onChange={changeSurName}></Input>
                </Col>
                <Col xl={12}>
                    <p style={{marginBottom: "2px"}}><b>Street and Number:</b></p>
                    <Input placeholder="Musterweg 6" size="large" value={streetAndNumber}
                           onChange={changeStreetAndNumber}></Input>
                </Col>
                <Col xl={12}>
                    <p style={{marginBottom: "2px"}}><b>Postcode and City:</b></p>
                    <Input placeholder="79098 Freiburg" size="large" value={zipAndCity}
                           onChange={changeZipAndCity}></Input>
                </Col>
                <Col xl={12}>
                    <p style={{marginBottom: "2px"}}><b>Country:</b></p>
                    <Input placeholder="Deutschland" size="large" value={country} onChange={changeCountry}></Input>
                </Col>
                <Col xl={12}>
                    <p style={{marginBottom: "2px"}}><b>E-Mail:</b></p>
                    <Input placeholder="melanie@musterfrau.com" size="large" value={email}
                           onChange={changeEmail}></Input>
                </Col>
                <Col xl={12} style={{marginTop: "1em"}}>
                    <Checkbox onChange={confirmGTC}>I've read and accept the <a href="/agb" target="_blank">general terms and conditions</a></Checkbox>
                </Col>
                <Col xl={12} style={{marginTop: "1em"}}>
                    <Checkbox onChange={confirmWSDCRules}>I've read and accept <a href="/eventrules" target="_blank">event rules and WSDC code of conduct</a></Checkbox>
                </Col>
            </Row>
        </div>
    )
}

export default GuestInfoForm;